import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export const useAffiliateTracking = () => {
  const { user } = useAuth();

  useEffect(() => {
    // Capturar código de afiliado da URL quando usuário acessa o site
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get('ref');
    
    console.log('Verificando URL para código de afiliado...', window.location.href);
    console.log('Código encontrado na URL:', refCode);
    console.log('Código já salvo no localStorage:', localStorage.getItem('affiliateCode'));
    
    if (refCode) {
      // Salvar no localStorage para persistir durante a sessão
      localStorage.setItem('affiliateCode', refCode);
      console.log('Código de afiliado detectado e salvo:', refCode);
    }

    // Se usuário se cadastra/loga e tem código salvo, registrar lead
    if (user) {
      const savedCode = localStorage.getItem('affiliateCode');
      if (savedCode) {
        trackAffiliateSignup(savedCode, user.id);
        // Não remover o código ainda, pode precisar para compras
      }
    }
  }, [user]);

  const trackAffiliateSignup = async (affiliateCode: string, newUserId: string) => {
    try {
      const { data, error } = await supabase.rpc('record_affiliate_lead', {
        p_affiliate_code: affiliateCode,
        p_customer_user_id: newUserId
      });

      if (error) {
        console.error('Erro ao registrar lead do afiliado:', error);
        return null;
      }

      if (data && typeof data === 'object' && 'success' in data && data.success) {
        console.log('Lead de afiliado registrado com sucesso');
        return data;
      } else {
        console.log('Erro ao registrar lead:', data && typeof data === 'object' && 'error' in data ? data.error : 'Erro desconhecido');
        return null;
      }
    } catch (error) {
      console.error('Erro no tracking de afiliado:', error);
      return null;
    }
  };

  // Function to get affiliate info from stored code
  const getAffiliateInfo = async (affiliateCode: string) => {
    try {
      const { data: affiliate, error } = await supabase
        .from('affiliate_codes')
        .select('code, user_id')
        .eq('code', affiliateCode)
        .eq('is_active', true)
        .single();

      if (error || !affiliate) {
        return null;
      }

      const { data: profile } = await supabase
        .from('profiles')
        .select('first_name, email')
        .eq('id', affiliate.user_id)
        .single();

      return {
        code: affiliate.code,
        affiliateName: profile?.first_name || 'Usuário',
        affiliateEmail: profile?.email
      };
    } catch (error) {
      console.error('Erro ao buscar informações do afiliado:', error);
      return null;
    }
  };

  // Função para obter o código de afiliado salvo
  const getStoredAffiliateCode = () => {
    return localStorage.getItem('affiliateCode');
  };

  // Função para limpar o código após uso
  const clearAffiliateCode = () => {
    localStorage.removeItem('affiliateCode');
  };

  return {
    getStoredAffiliateCode,
    clearAffiliateCode,
    getAffiliateInfo
  };
};